import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import { SEARCHABLE_ORG_TYPES_MAP } from '#/utils/constants/general/orgTypes';

export function orgTypeFacet(i18n: I18nFn) {
  return {
    id: 'orgTypeFacet',
    name: 'orgType',
    get title() {
      return i18n('Org Type');
    },
    type: 'array',
    options: Object.keys(SEARCHABLE_ORG_TYPES_MAP(i18n)),
    optionTitles: SEARCHABLE_ORG_TYPES_MAP(i18n),
    sort: false,
  } as const satisfies SearchFacetData;
}
